import { IconWeight, WarningCircle } from "@phosphor-icons/react";
import { Intent, intentToHexColor } from "../intent";
import twMerge from "../../lib/twMerge";

export default function ErrorCircle({
  className,
  size,
  weight = "regular",
  intent = "danger",
  style,
}: {
  className?: string;
  size?: number;
  weight?: IconWeight;
  intent?: Intent;
  style?: React.CSSProperties;
}): React.ReactElement {
  return (
    <WarningCircle
      className={twMerge("flex-shrink-0", className)}
      size={size || 14.5}
      color={intentToHexColor(intent)}
      weight={weight}
      style={style}
    />
  );
}
